// @/services/content/store/modules/self-assessment-bs-questions.js
export class SelfAssessmentBSQuestionsHandler {
  constructor(store) {
    this.store = store;
  }

  /**
   * Get Self Assessment Business Segments Questions content by locale
   * @param {string} locale Locale to get content for
   * @returns {Object|null} Content or null if not found
   */
  getContent(locale = 'en') {
    // Try requested locale first
    const localeContent = this.store.state.data.selfAssessmentBSQuestions?.[locale];
    if (localeContent) return localeContent;
    
    // Fall back to English if different locale was requested
    if (locale !== 'en') {
      return this.store.state.data.selfAssessmentBSQuestions?.['en'] || null;
    }
    
    return null;
  }

  /**
   * Get question text by ID and locale
   * @param {string} questionId Question identifier (e.g., 'EE01')
   * @param {string} locale Locale to get content for
   * @returns {string|null} Localized question text or null if not found
   */
  getQuestionText(questionId, locale = 'en') {
    const content = this.getContent(locale);
    const field = `${questionId}_text`;
    return content?.[field] || null;
  }

  /**
   * Get question help text by ID and locale
   * @param {string} questionId Question identifier (e.g., 'EE01')
   * @param {string} locale Locale to get content for
   * @returns {string|null} Localized help text or null if not found
   */
  getQuestionHelpText(questionId, locale = 'en') {
    const content = this.getContent(locale);
    const field = `${questionId}_help`;
    return content?.[field] || null;
  }

  /**
   * Get question short title by ID and locale
   * @param {string} questionId Question identifier (e.g., 'EE01')
   * @param {string} locale Locale to get content for
   * @returns {string|null} Localized short title or null if not found
   */
  getQuestionShortTitle(questionId, locale = 'en') {
    const content = this.getContent(locale);
    const field = `${questionId}_short`;
    return content?.[field] || null;
  }
}
